import WaitForReports from './WaitForReports';

export default WaitForReports;